import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import store from '../../store';

import ServiceWrapper from './serviceWrapper'

export default  class aService extends Component {
	render() {
		return (<ServiceWrapper {...this.props}>
						<article class="has-widget">
							<p>DolphinHost™ mākoņskaitļošanas datu centrā izvietots faksa numurs, kas nodrošina faksa pakalpojumus, izmantojot interneta pārlūku vai pārsūtot saņemtos faksus uz e-pastu.</p>
							<h2>Priekšrocības</h2>
							<ul>
								<li>Nav nepieciešams izdrukāt dokumentus, lai tos nosūtītu pa faksu</li>
								<li>Ērta faksu nosūtīšana un piekļuve saņemtajiem faksiem no jebkuras vietas, izmantojot datoru vai mobilo tālruni</li>
								<li>Datu centra un faksu uzglabāšanas infrastruktūras atbilstība GDPR datu aizsardzības regulai</li>
								<li>Izdevīgi tarifi faksu nosūtīšanai uz ārzemēm (īpaši uz valstīm, kur fakss vēljoprojām tiek aktīvi izmantots)</li>
							</ul>
							<p></p>
						</article>
						<div class="widget plan">
							<h3><span class="from"><Text id="cart.from"/></span><span class="value">€5</span><span class="term"> <Text id="cart.month.full"/></span></h3>
						     <ul class="bullet">
						     	<li>Bezmaksas ierīkošana</li>
						     	<li>10% atlaide maksājot par 12 mēnešiem</li>
						     </ul>
						     <div><Link href={store.prefix+'/contact?service=fax&form=true'} class="button"><Text id="email.widget.list.btn"/></Link></div>
						</div>
				</ServiceWrapper>);
	}
}



// WEBPACK FOOTER //
// ./routes/services/fax.js